import { Col, Flex, Form, Row } from "antd";
import DynamicFormCase from "../DynamicFieldRenderer/DynamicFieldRenderer";
import { useWatch } from "antd/es/form/Form";
import { useEffect, useState } from "react";
//import { Padding } from "@mui/icons-material";

const TableFilters = ({ config, handleButtonClick = () => { },isReset,dashboardId }: any) => {
  //console.log("~ file: TableFilters.tsx:5 ~ TableFilters ~ config:", config);
  
  const [form] = Form.useForm();
  const CategoryTypeIs = useWatch("CategoryType",form);
  const [modifiedConfig, setModifiedConfig] = useState<any>(config);

  useEffect(() => {

  if (dashboardId != 10) {
    setModifiedConfig(config); // fallback
    return;
  }

  const updatedConfig = JSON.parse(JSON.stringify(config)); // Deep clone
  
  updatedConfig?.fields?.forEach((section: any) => {
    section.content = section.content
      .filter((field: any) => {
        console.log('category type is ',CategoryTypeIs)
        if (
          dashboardId == 10 &&
          (CategoryTypeIs == 2 || CategoryTypeIs == "Declaration") &&
          field.name.toLowerCase() == "cycle"
        ) {
          form.setFieldValue("Cycle", undefined); 
          return false;
        }
        return true;
      })
      .map((field: any) => {
        if (field.name.toLowerCase() === "categorytype" && CategoryTypeIs == undefined) {
          form.setFieldValue("CategoryType", "Declaration");
        }
        if (field.name.toLowerCase() == "status" && Array.isArray(field.fieldOptions)) {
          if (CategoryTypeIs == 2 || CategoryTypeIs == undefined || CategoryTypeIs == "Declaration" ) {
            field.fieldOptions = field.fieldOptions.filter(
              (option: any) =>
                option.label.toLowerCase() == "pending" || option.label.toLowerCase() == "submitted"
            );
          } else if (CategoryTypeIs == 1) {
            field.fieldOptions = field.fieldOptions.filter(
              (option: any) => option.label.toLowerCase() != "submitted"
            );
          }
        }

        return field;
      });
  });
  
  setModifiedConfig(updatedConfig);
}, [config, CategoryTypeIs, dashboardId]);


  const onFinish = (values: any) => {
    console.log("Form Values:", values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: "100%" }}
    >
      <div>
        {modifiedConfig?.fields?.map((section: any) => (
          <div key={section.key}>
            {/* Render content without Collapse */}
            {Array.isArray(section.content) && section.content.length > 0 ? (
              <Row
                gutter={[16, 8]}
                style={section.boxStyle}
                justify={section.justify}
                align={section.alignItems}
              >
                {section.content.map((field: any, index: number) => {
                  if (field.type.toLowerCase() == "button") {
                    return (
                      <Col lg={24}>
                        <div className="w-100 d-flex justify-content-end">
                          <Flex
                            style={field.boxStyle}
                            justify={field.justify}
                            align={field.alignItems}
                            key={index}
                            className="gap-2"
                          >
                            <DynamicFormCase
                              field={field}
                              form={form}
                              {...field}
                              handleButtonClick={handleButtonClick}
                              keyIdentity={section.key}
                              actionType={field.actionKey}
			      isReset={isReset}
                            />
                          </Flex>
                        </div>
                      </Col>
                    );
                  }
                  return (
                    <Col style={{ padding: '0' }}
                      lg={field.type.toLowerCase() == "addrowtable" ? 24 : 6}
                      md={field.type.toLowerCase() == "addrowtable" ? 24 : 8}
                      xs={field.type.toLowerCase() == "addrowtable" ? 24 : 24}
                      sm={field.type.toLowerCase() == "addrowtable" ? 24 : 24}
                      key={index}
                    >
                      <DynamicFormCase
                        field={field}
                        form={form}
                        keyIdentity={""}
                        actionType={""}
                        fields={undefined}
                        dataSource={undefined}
                        colsize={24}
                      />
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <p>No fields available</p>
            )}
          </div>
        ))}
      </div>
    </Form >
  );
};

export default TableFilters;
